import Client from '../axiosClient'
const resource = '/seo';
const resourceInit = '/seo_initialize';
const resourceDelete = '/seo_delete';

export default {
  init() {
    return Client.get(`${resourceInit}`);
  },
  get(payload) {
    if(payload) {
     // let dashPartnerId = payload['dashPartnerId'] != undefined ? payload['dashPartnerId'] : "0";
      return Client.get(`${resource}?page=${payload['pageNo']}&pageLength=${payload['pageLength']}`);
    }
    return Client.get(`${resource}`);
  },

  getById(id) {
    return Client.get(`${resource}/${id}`);
  },

  delete(payload) {
    return Client.post(`${resourceDelete}`, payload);
  },
  
  post(payload) {
    return Client.post(`${resource}`, payload);
  },



};



// WEBPACK FOOTER //
// ./src/repositories/events/SeoRepository.js